import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { HeroContainer, HeroContent } from './Hero.styles';

const Hero = () => {
    const scrollToContact = () => {
        const contactSection = document.getElementById('contact');
        if (contactSection) {
            contactSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <HeroContainer id="home">
            <Container maxWidth="lg">
                <HeroContent>
                    <Typography
                        variant="h1"
                        color="white"
                        sx={{
                            fontWeight: 700,
                            fontSize: {
                                xs: '2.5rem',
                                md: '3.5rem',
                                lg: '4rem',
                            },
                            textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                        }}
                    >
                        Done Right Home Services
                    </Typography>
                    <Typography
                        variant="subtitle1"
                        color="text.secondary"
                        sx={{
                            fontWeight: 600,
                            mb: 3,
                        }}
                    >
                        CCB #253480 - licensed, bonded and insured
                    </Typography>
                    <Typography
                        variant="h5"
                        color="white"
                        paragraph
                        sx={{
                            maxWidth: '800px',
                            mb: 4,
                            textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
                        }}
                    >
                        Professional handyman services with a focus on quality
                        and customer satisfaction. We may not be the cheapest or
                        the fastest, but you can count on it being done right.
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            onClick={scrollToContact}
                            sx={{
                                px: 4,
                                py: 1.5,
                                fontSize: '1.1rem',
                                fontWeight: 600,
                            }}
                        >
                            Get a Free Quote
                        </Button>
                        <Button
                            variant="outlined"
                            color="secondary"
                            size="large"
                            href="#services"
                            sx={{
                                px: 4,
                                py: 1.5,
                                fontSize: '1.1rem',
                                fontWeight: 600,
                                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                borderColor: 'white',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                    borderColor: 'white',
                                },
                            }}
                        >
                            Our Services
                        </Button>
                    </Box>
                </HeroContent>
            </Container>
        </HeroContainer>
    );
};

export default Hero;
